import parameterLabels from './parameterLabels.json';
import { debugLog } from '../utils/logger';

// Centralized tooltip configuration for admin control
// Admins can modify these explanations without touching component code
// For easier admin management, tooltips can also be loaded from admin-tooltips.json

const normalizeKey = (key) => {
  if (!key) return '';
  return key
    .replace(/_/g, ' ')
    .replace(/\b([a-z])/g, (match) => match.toUpperCase())
    .trim();
};

const buildDefaultTooltips = () => {
  return Object.entries(parameterLabels).reduce((acc, [parameterId, info]) => {
    if (!info) {
      return acc;
    }
    const title = info.label ?? normalizeKey(parameterId.split('.').pop());
    const description = info.description ?? '';
    if (!title && !description) {
      return acc;
    }
    acc[parameterId] = {
      title,
      description,
    };
    return acc;
  }, {});
};

// Default tooltips (fallback if JSON loading fails)
const DEFAULT_TOOLTIPS = buildDefaultTooltips();

// Tooltip categories for better organization
export const TOOLTIP_CATEGORIES = {
  BACKGROUND: 'Background Processing',
  DEPTH: 'Depth & 3D Analysis', 
  MESH: '3D Mesh Creation',
  POINTCLOUD: 'Point Cloud Generation',
  GENERAL: 'General Settings'
};

// Helper function to get tooltip by parameter ID
export const getTooltip = (parameterId) => {
  return PARAMETER_TOOLTIPS[parameterId] || null;
};

// Helper function to check if parameter has tooltip
export const hasTooltip = (parameterId) => {
  return parameterId in PARAMETER_TOOLTIPS;
};

// Load tooltips from JSON file or use defaults
let PARAMETER_TOOLTIPS = DEFAULT_TOOLTIPS;

// Try to load admin-configured tooltips
try {
  import('./admin-tooltips.json').then(adminConfig => {
    if (adminConfig.tooltips) {
      PARAMETER_TOOLTIPS = { ...DEFAULT_TOOLTIPS, ...adminConfig.tooltips };
    }
  }).catch(() => {
    // Fallback to defaults if JSON loading fails
    debugLog('Using default tooltips - admin configuration not found');
  });
} catch (error) {
  debugLog('Using default tooltips - admin configuration not available');
}

export { PARAMETER_TOOLTIPS };

// Admin function to add/update tooltips (for future admin panel)
export const updateTooltip = (parameterId, tooltipData) => {
  PARAMETER_TOOLTIPS[parameterId] = tooltipData;
};
